exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2ZUD-rdXggJZAtpyRo0kXN {\n  position: relative;\n  width: auto;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  background-color: inherit;\n}\n", ""]);

// exports
exports.locals = {
	"scrollingContainer": "_2ZUD-rdXggJZAtpyRo0kXN"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Graphs/components/ScrollingContainer/ScrollingContainer.css
// module id = 9789
// module chunks = 23